import { DefaultTheme } from '@mui/styles'
import { VariantType } from 'notistack'

export const getIconColor = (theme: DefaultTheme, variant?: VariantType) => {
  switch (variant) {
    case 'success':
      return theme.palette.successCard.contrastText
    case 'error':
      return theme.palette.errorCard.contrastText
    case 'info':
      return theme.palette.infoCard.contrastText
    case 'warning':
      return theme.palette.warningCard.contrastText
    default:
      return theme.palette.lightGrey.main
  }
}
